import script from "./WorkWriters.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkWriters.vue?vue&type=script&setup=true&lang=ts"

import "./WorkWriters.vue?vue&type=style&index=0&id=e74de386&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e74de386"]])

export default __exports__